import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  font-family: Arial;

  select {
    font-size: 16px;
    height: 40px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    background-color: #006600;
    color: ${(props) => props.theme.colors.white};
    margin-left: 50px;

    label + & {
      margin-left: 0px;
      border-radius: 0px;
      background-color: ${(props) => props.theme.colors.white};
      color: #${(props) => props.theme.colors.gray7};
    }
  }
`;
